import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import ProductDetailLensesFeatures from '../../../../ProductDetailLensesFeatures/ProductDetailLensesFeatures.js';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { getContactLensFeatures } from '../../utils/get-contactlens-features.js';
import { ProductDetailSpecificationContainer } from '../../../../ProductDetailSpecification/ProductDetailSpecificationContainer.js';

const LensesDescription = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant , colorFeatureIcons  } = useProductDetailContext();
    const labels = React.useMemo(()=>({
            description: activeVariant.description,
            header: activeVariant.header
        })
    , [
        getLabel,
        activeVariant
    ]);
    const { productFeatures , lensFeatures  } = React.useMemo(()=>getContactLensFeatures(activeVariant, getLabel)
    , [
        getLabel,
        activeVariant
    ]);
    return /*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        header: labels.header,
        description: labels.description
    }, /*#__PURE__*/ React.createElement(ProductDetailLensesFeatures, swcHelpers.extends({
        color: colorFeatureIcons
    }, lensFeatures)), /*#__PURE__*/ React.createElement(ProductDetailSpecificationContainer, {
        fallbackConfiguration: productFeatures
    }));
};

export { LensesDescription };
//# sourceMappingURL=LensesDescription.js.map
